<div class="fd-lines-header">
  <span class="f-s-16 f-w-600">Líneas</span>
  <button
    mat-flat-button
    color="primary"
    type="button"
    *ngIf="!isViewMode"
    (click)="addItem.emit()"
  >
    <mat-icon>add</mat-icon>
    Agregar ítem
  </button>
</div>

<div class="fd-lines-table-container">
  <table mat-table [dataSource]="items" class="fd-lines-table w-100">

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>Descripción</th>
      <td mat-cell *matCellDef="let item">
        <ng-container *ngIf="isViewMode; else fullDescription">
          <span
            class="fd-line-desc"
            [class.fd-line-desc--truncated]="shouldShortenDescription(item.description)"
            [matTooltip]="shouldShortenDescription(item.description) ? item.description : ''"
            matTooltipClass="fd-line-desc-tooltip"
          >
            {{ getShortDescription(item.description) }}
          </span>
        </ng-container>
        <ng-template #fullDescription>{{ item.description }}</ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="quantity">
      <th mat-header-cell *matHeaderCellDef class="col-quantity">Cant.</th>
      <td mat-cell *matCellDef="let item">{{ item.quantity }}</td>
    </ng-container>

    <ng-container matColumnDef="unitPrice">
      <th mat-header-cell *matHeaderCellDef class="col-price">Precio</th>
      <td mat-cell *matCellDef="let item" class="amount-cell">${{ item.unitPrice | number:'1.2-2' }}</td>
    </ng-container>

    <ng-container matColumnDef="subtotal">
      <th mat-header-cell *matHeaderCellDef class="col-amount">Subtotal</th>
      <td mat-cell *matCellDef="let item" class="amount-cell">${{ item.subtotal | number:'1.2-2' }}</td>
    </ng-container>

    <ng-container matColumnDef="taxRate">
      <th mat-header-cell *matHeaderCellDef class="col-tax">Impuesto</th>
      <td mat-cell *matCellDef="let item">
        <ng-container *ngIf="item.lineTaxes?.length">
          <span *ngFor="let t of item.lineTaxes" class="d-block f-s-12">{{ t.taxName }}</span>
        </ng-container>
        <ng-container *ngIf="!item.lineTaxes?.length">
          {{ item.taxRate > 0 ? (item.taxRate + '%') : 'Sin impuesto' }}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="taxAmount">
      <th mat-header-cell *matHeaderCellDef class="col-amount">Imp.</th>
      <td mat-cell *matCellDef="let item" class="amount-cell">${{ item.taxAmount | number:'1.2-2' }}</td>
    </ng-container>

    <ng-container matColumnDef="total">
      <th mat-header-cell *matHeaderCellDef class="col-amount">Total</th>
      <td mat-cell *matCellDef="let item" class="amount-cell total">${{ item.total | number:'1.2-2' }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="col-actions"></th>
      <td mat-cell *matCellDef="let item; let i = index">
        <button mat-icon-button color="primary" type="button"
          (click)="editItem.emit(i)" matTooltip="Editar ítem">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button color="warn" type="button"
          (click)="removeItem.emit(i)"
          [disabled]="itemsCount <= 1"
          matTooltip="Eliminar ítem">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns;"></tr>
  </table>
</div>
